import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, GlobeIcon, ArrowRightIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function GetStartedSlide() {
  return <SlideLayout className="text-center relative" data-id="element-165" data-mp="1bzurywuafoar">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-teal/10 blur-[150px] rounded-full pointer-events-none" data-id="element-166" data-mp="1gxd1opg4q7jt" />

      <motion.div variants={itemVariants} className="mb-8 relative z-10" data-id="element-167" data-mp="24lmifcyhk543">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-168" data-mp="28o9ghvlr2m9q">
          We Are Onboarding <br data-id="element-169" data-mp="1up1fcx61142w" />
          <span className="text-brand-teal" data-id="element-170" data-mp="1urdy3cjlzih0">Design Partners Now</span>
        </h2>
        <p className="text-lg text-brand-text-dim max-w-3xl mx-auto" data-id="element-171" data-mp="1zmjfby22g8yr">
          We are looking for production AI teams who want to be first to run on
          FPGA-accelerated inference.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10 relative z-10 text-left" data-id="element-172" data-mp="o6urz5kwh7xf">
        <motion.div variants={itemVariants} className="bg-brand-bg-card/80 backdrop-blur-sm border border-brand-border rounded-2xl p-6" data-id="element-173" data-mp="cm8gpl959709">
          <h3 className="text-lg font-bold text-brand-text mb-3 flex items-center gap-2" data-id="element-174" data-mp="qnb4q3jp8rdt">
            <span className="text-brand-teal" data-id="element-175" data-mp="llc0krg4xqft">What you get</span>
          </h3>
          <ul className="space-y-2 text-sm text-brand-text-dim" data-id="element-176" data-mp="zlmrtvlcx71i">
            <li className="flex items-start gap-2" data-id="element-177" data-mp="vlcmml5e2knp">
              <span className="text-brand-teal mt-0.5" data-id="element-178" data-mp="vkl0s21lg1am">✓</span> Early access to
              the API
            </li>
            <li className="flex items-start gap-2" data-id="element-179" data-mp="19elrq9mb0k0f">
              <span className="text-brand-teal mt-0.5" data-id="element-180" data-mp="14d4tklv7fbnj">✓</span> Preferred
              pricing
            </li>
            <li className="flex items-start gap-2" data-id="element-181" data-mp="1jbqeaak2ahhr">
              <span className="text-brand-teal mt-0.5" data-id="element-182" data-mp="1ebklus5ywqym">✓</span> Direct line to
              the engineering team
            </li>
            <li className="flex items-start gap-2" data-id="element-183" data-mp="1lfk2tulxmqe1">
              <span className="text-brand-teal mt-0.5" data-id="element-184" data-mp="1lcpjy7ikhdmq">✓</span> Influence on
              model roadmap priority
            </li>
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-brand-bg-card/80 backdrop-blur-sm border border-brand-border rounded-2xl p-6" data-id="element-185" data-mp="1vc6lccqsd5cw">
          <h3 className="text-lg font-bold text-brand-text mb-3 flex items-center gap-2" data-id="element-186" data-mp="2531hq9xqxlc2">
            <span className="text-brand-text-muted" data-id="element-187" data-mp="2943aq912l15l">What we ask</span>
          </h3>
          <ul className="space-y-2 text-sm text-brand-text-dim" data-id="element-188" data-mp="2967p5kwlhik4">
            <li className="flex items-start gap-2" data-id="element-189" data-mp="2e3zgacpf10n9">
              <span className="text-brand-border mt-0.5" data-id="element-190" data-mp="2j2aokj02b33d">■</span> A non-binding
              LOI signaling intent
            </li>
            <li className="flex items-start gap-2" data-id="element-191" data-mp="jqgjj537lm30">
              <span className="text-brand-border mt-0.5" data-id="element-192" data-mp="ooi5pyvxm1ip">■</span> Feedback on
              which models matter most
            </li>
            <li className="flex items-start gap-2" data-id="element-193" data-mp="h58tzyzydqqh">
              <span className="text-brand-border mt-0.5" data-id="element-194" data-mp="h73e5b3eheti">■</span> Your specific
              latency targets
            </li>
          </ul>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="relative z-10 flex flex-col items-center gap-4" data-id="element-195" data-mp="7fpb4tc8pwvm">
        <a href="mailto:founders@isochron.cloud" className="group flex items-center gap-3 text-2xl md:text-3xl font-bold text-brand-text hover:text-brand-teal transition-colors" data-id="element-196" data-mp="2e019h0r7p94">
          <MailIcon className="w-7 h-7 text-brand-teal group-hover:scale-110 transition-transform" data-id="element-197" data-mp="v2xdb2edgptf" />
          founders@isochron.cloud
        </a>

        <a href="https://isochron.cloud" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-lg text-brand-text-dim hover:text-brand-text transition-colors" data-id="element-198" data-mp="l5kg7g7yrz42">
          <GlobeIcon className="w-5 h-5" data-id="element-199" data-mp="35yxokse447bh" />
          isochron.cloud
        </a>
      </motion.div>

      <motion.div variants={itemVariants} className="mt-8 relative z-10" data-id="element-200" data-mp="yjjlkw7lsb2a">
        <p className="text-brand-text-muted font-mono text-sm" data-id="element-201" data-mp="13dw5t8gwlqf3">
          One API-key swap. No hardware knowledge. No vendor lock-in.
        </p>
      </motion.div>
    </SlideLayout>;
}